import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
    removeConfirmState,
    dispatchAction,
    onChange
} from "@redux-action/datatable/confirmAction";
import TypeAhead from "./TypeAhead";
export const ConfirmModal = ({
    confirmState: { title, message, model_comment, action },
    component,
    removeConfirmState,
    dispatchAction,
    onChange
}) => {
    return (
        <div
            id="modal-confirm-react"
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            style={{ top: 40 + 'px' }}
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button
                            type="button"
                            className="close view-enabled"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={removeConfirmState}
                        >
                            <span
                                onClick={removeConfirmState}
                                aria-hidden="true"
                            >
                                &times;
                            </span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <p className="modal-message">{message}</p>
                        {["orders",
                            "tasks",
                            "orders/line_items"].includes(
                            component
                        ) &&
                        ["reject",
                            "cancel",
                            "hold",
                            "release"].includes(
                            action
                        ) ? (
                                <textarea
                                    onChange={onChange}
                                    className="form-control"
                                    placeholder="Please enter a reason..."
                                    name="modal_comment"
                                    value={model_comment}
                                />
                            ) : (
                                ""
                            )}

                        {["orders", "tasks"].includes(component) &&
                        ["reassign"].includes(action) ? (
                                <TypeAhead onChange={onChange} />
                            ) : (
                                ""
                            )}

                        {["properties"].includes(component) &&
                        ["merge"].includes(action) && (
                            <TypeAhead onChange={onChange} />
                        )}
                    </div>

                    <div className="modal-footer">
                        <button
                            data-component={component}
                            onClick={dispatchAction}
                            type="submit"
                            data-dismiss="modal"
                            className="btn btn-primary view-enabled"
                        >
                            Yes
                        </button>
                        <button
                            onClick={removeConfirmState}
                            type="button"
                            className="btn btn-secondary view-enabled"
                            data-dismiss="modal"
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ConfirmModal.propTypes = {
    confirmState: PropTypes.object,
    component: PropTypes.string,
    removeConfirmState: PropTypes.func,
    dispatchAction: PropTypes.func,
    onChange: PropTypes.func
};

const mapStateToProps = state => ({ confirmState: state.datatable.confirmState });

export default connect(mapStateToProps, {
    removeConfirmState,
    dispatchAction,
    onChange
})(ConfirmModal);
